module.exports = __webpack_public_path__ + "static/media/core.7d349090.mp4";